import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import _get from 'lodash/get';
// Serialization
import { deserialize } from 'serializr';
import { installationLogSchema } from './schemas';
// Color
import { installationLogResultPalette } from '../components/core/colors';
// Permissions
import permissions from '../constants/Permissions';
// Models
import mAccessWay from './accessWay';
import mCustomer from './customer';
import mDevice from './device';
import mScenario from './scenario';
// Custom
import { SEARCHFIELD_TYPES } from '../constants/App';
import { findInList } from '../utils/Tools';

/**
* Serialization
*/
const deserializeInstallationLog = (data) => deserialize(installationLogSchema, data);

/**
* Lists
*/
const installationLogTypesList = [
  {
    key: 'access',
    value: 'access',
    labelId: 'installationLog.type.access',
    icon: 'iLogTypeAccess',
  },
  {
    key: 'on_demand',
    value: 'on_demand',
    labelId: 'installationLog.type.on_demand',
    icon: 'iLogTypeOnDemand',
  },
  {
    key: 'api',
    value: 'api',
    labelId: 'installationLog.type.api',
    icon: 'iLogTypeApi',
  },
  {
    key: 'api_right',
    value: 'api_right',
    labelId: 'installationLog.type.api_right',
    icon: 'iLogTypeApiRight',
  },
  {
    key: 'task',
    value: 'task',
    labelId: 'installationLog.type.task',
    icon: 'iLogTypeTask',
  },
  {
    key: 'trigger',
    value: 'trigger',
    labelId: 'installationLog.type.trigger',
    icon: 'iLogTypeTrigger',
  },
];

const installationLogResultsList = [
  {
    key: 'ok',
    value: 'ok',
    labelId: 'installationLog.value.ok',
    icon: 'success',
    color: installationLogResultPalette.success,
  },
  {
    key: 'license_plate_fallback_code',
    value: 'license_plate_fallback_code',
    labelId: 'installationLog.value.license_plate_fallback_code',
    icon: 'success',
    color: installationLogResultPalette.success,
  },
  {
    key: 'drop_off',
    value: 'drop_off',
    labelId: 'installationLog.value.drop_off',
    icon: 'success',
    color: installationLogResultPalette.success,
  },
  {
    key: 'anonymous_call',
    value: 'anonymous_call',
    labelId: 'installationLog.value.anonymous_call',
    icon: 'forbid',
    color: installationLogResultPalette.error,
  },
  {
    key: 'access_way_disabled',
    value: 'access_way_disabled',
    labelId: 'installationLog.value.access_way_disabled',
    icon: 'forbid',
    color: installationLogResultPalette.error,
  },
  {
    key: 'unknown_access_way',
    value: 'unknown_access_way',
    labelId: 'installationLog.value.unknown_access_way',
    icon: 'forbid',
    color: installationLogResultPalette.error,
  },
  {
    key: 'no_right',
    value: 'no_right',
    labelId: 'installationLog.value.no_right',
    icon: 'forbid',
    color: installationLogResultPalette.error,
  },
  {
    key: 'right_disabled',
    value: 'right_disabled',
    labelId: 'installationLog.value.right_disabled',
    icon: 'forbid',
    color: installationLogResultPalette.error,
  },
  {
    key: 'right_date',
    value: 'right_date',
    labelId: 'installationLog.value.right_date',
    icon: 'forbid',
    color: installationLogResultPalette.error,
  },
  {
    key: 'right_planning',
    value: 'right_planning',
    labelId: 'installationLog.value.right_planning',
    icon: 'forbid',
    color: installationLogResultPalette.error,
  },
  {
    key: 'scenario_trigger_disabled',
    value: 'scenario_trigger_disabled',
    labelId: 'installationLog.value.scenario_trigger_disabled',
    icon: 'forbid',
    color: installationLogResultPalette.error,
  },
  {
    key: 'antipassback_state',
    value: 'antipassback_state',
    labelId: 'installationLog.value.antipassback_state',
    icon: 'forbid',
    color: installationLogResultPalette.error,
  },
  {
    key: 'disabled',
    value: 'disabled',
    labelId: 'installationLog.value.disabled',
    icon: 'forbid',
    color: installationLogResultPalette.error,
  },
  {
    key: 'permanent_exit',
    value: 'permanent_exit',
    labelId: 'installationLog.value.permanent_exit',
    icon: 'forbid',
    color: installationLogResultPalette.error,
  },
  {
    key: 'forbidden_entry',
    value: 'forbidden_entry',
    labelId: 'installationLog.value.forbidden_entry',
    icon: 'forbid',
    color: installationLogResultPalette.error,
  },
  {
    key: 'forbidden_exit',
    value: 'forbidden_exit',
    labelId: 'installationLog.value.forbidden_exit',
    icon: 'forbid',
    color: installationLogResultPalette.error,
  },
  {
    key: 'allotment_not_found',
    value: 'allotment_not_found',
    labelId: 'installationLog.value.allotment_not_found',
    icon: 'forbid',
    color: installationLogResultPalette.error,
  },
  {
    key: 'allotment_planning',
    value: 'allotment_planning',
    labelId: 'installationLog.value.allotment_planning',
    icon: 'forbid',
    color: installationLogResultPalette.error,
  },
  {
    key: 'allotment_and_entity_capacity',
    value: 'allotment_and_entity_capacity',
    labelId: 'installationLog.value.allotment_and_entity_capacity',
    icon: 'forbid',
    color: installationLogResultPalette.error,
  },
  {
    key: 'ignored_license_plate',
    value: 'ignored_license_plate',
    labelId: 'installationLog.value.ignored_license_plate',
    icon: 'forbid',
    color: installationLogResultPalette.error,
  },
  {
    key: 'forbidden_entry_during_exit_courtesy_delay',
    value: 'forbidden_entry_during_exit_courtesy_delay',
    labelId: 'installationLog.value.forbidden_entry_during_exit_courtesy_delay',
    icon: 'forbid',
    color: installationLogResultPalette.error,
  },
];

/**
* Utils
*/
const installationLogResult = (log) => {
  if (!log) return null;
  const FORBIDDEN_LOG = { scenario: false, icon: 'forbid', color: installationLogResultPalette.error }; // ❌
  const DROP_OFF_LOG = { scenario: false, icon: 'success', color: installationLogResultPalette.success }; // ✅
  const SUCCESS_LOG = { scenario: false, icon: 'success', color: installationLogResultPalette.success }; // ✅
  const SCENARIO_SUCCESS_LOG = { scenario: true, icon: 'success', color: installationLogResultPalette.success }; // ✅
  const SCENARIO_WARNING_LOG = { scenario: true, icon: 'warning', color: installationLogResultPalette.warning }; // 🚧
  const NO_SCENARIO_LOG = { scenario: false, icon: 'unknown', color: installationLogResultPalette.warning }; // 🚧

  /* Ok: check scenario log status */
  /* ----------------------------- */
  if (log.value === 'ok') {
    if (log.scenario_log) return log.scenario_log.status === 'success' ? SCENARIO_SUCCESS_LOG : SCENARIO_WARNING_LOG;
    return NO_SCENARIO_LOG;
  }

  /* Fallback code : success */
  /* ----------------------- */
  if (log.value === 'license_plate_fallback_code') return SUCCESS_LOG;

  /* Drop off: check scenario log status */
  /* ----------------------------------- */
  if (log.value === 'drop_off') return DROP_OFF_LOG;

  /* Not ok or not drop off */
  /* ---------------------- */
  return FORBIDDEN_LOG;
};

const installationLogCustomer = (log) => {
  if (!log || !log.customer) {
    return '';
  }
  return mCustomer.fullName(log.customer);
};

const installationLogSourceIcon = (log) => {
  if (!log) {
    return null;
  }
  switch (log.type) {
    case 'access':
    case 'on_demand':
      return mDevice.triggerIcon(log.trigger);
    case 'api':
    case 'api_right':
    case 'task':
    case 'trigger':
      return findInList(installationLogTypesList, 'value', log, 'type').icon;
    default:
      return 'unknown';
  }
};

const installationLogEquipmentName = (log) => {
  if (!log) {
    return null;
  }
  if (!!log.trigger && !!log.trigger.equipment) {
    return ` - ${log.trigger.equipment.name}`;
  }
  return '';
};

const installationLogSourceName = (log, countryCode) => {
  if (!log) {
    return null;
  }
  switch (log.type) {
    case 'access':
    case 'on_demand':
      if (log.value === 'anonymous_call') {
        return log.value;
      }
      // Build an access way based on log desc and log trigger
      return `${mAccessWay.desc({ type: mAccessWay.typeFromTrigger(log.trigger), desc: log.desc }, countryCode)} ${installationLogEquipmentName(log)}`;
    case 'task':
      if (log.task) {
        return log.task.name;
      }
      return 'noTaskName';
    default:
      return '';
  }
};

const installationLogScenarioTriggerType = (log) => findInList(mScenario.triggerTypesList, 'value', log, 'scenario_trigger_type');

const isIgnored = (log) => _get(log, 'ignored', false);

/**
* Model
*/
const installationLog = {
  // Name and icon
  name: 'installationLog',
  icon: null,

  // Serialization
  deserialize: deserializeInstallationLog,

  // Lists
  typesList: installationLogTypesList,
  resultsList: installationLogResultsList,

  // Utils
  result: installationLogResult,
  customer: installationLogCustomer,
  sourceIcon: installationLogSourceIcon,
  sourceName: installationLogSourceName,
  scenarioTriggerType: installationLogScenarioTriggerType,
  isIgnored,

  // List features
  listFeatures: {
    // Default list params
    defaultParams: {
      pagination: {
        page: 1,
        pageSize: 20,
      },
      sort: [
        { field: 'date', dir: 'desc' },
      ],
    },

    // Columns
    columnsQuantity: () => ({
      xs: 2,
      sm: 2,
      md: 4,
      lg: 4,
      xl: 4,
    }),
    columns: [
      {
        key: 'date',
        labelId: 'field.date',
        field: 'date',
        sortable: true,
      },
      {
        key: 'type',
        labelId: 'field.source',
        field: 'type',
        alias: 'source',
        secondarySorts: [
          { field: 'date', dir: 'desc' },
        ],
        sortable: true,
        className: 'hidden-sm-down',
      },
      {
        key: 'customer',
        labelId: 'field.customer',
        field: 'customer.lastname',
        alias: 'customer',
        secondarySorts: [
          { field: 'date', dir: 'desc' },
        ],
        sortable: true,
        className: 'hidden-sm-down',
      },
      {
        key: 'value',
        labelId: 'field.resultScenario',
        field: 'value',
        alias: 'scenario',
        sortable: true,
        secondarySorts: [
          { field: 'scenario_log.scenario.name', dir: 'asc' },
          { field: 'date', dir: 'desc' },
        ],
      },
    ],

    // Search fields
    searchFields: [
      {
        key: 'begin',
        labelId: 'field.afterDate',
        field: 'begin',
        initial: null,
        isUndefined: (value) => _isNil(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.date,
        scope: 'after',
        filter: {
          field: 'date',
        },
      },
      {
        key: 'end',
        labelId: 'field.beforeDate',
        field: 'end',
        initial: null,
        isUndefined: (value) => _isNil(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.date,
        scope: 'before',
        filter: {
          field: 'date',
        },
      },
      {
        key: 'type',
        labelId: 'field.type',
        field: 'type',
        initial: null,
        isUndefined: (value) => _isNil(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.enum,
        filter: {
          field: 'type',
        },
      },
      {
        key: 'result',
        labelId: 'field.result',
        field: 'result',
        initial: null,
        isUndefined: (value) => _isNil(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.enum,
        filter: {
          field: 'value',
        },
      },
      {
        key: 'desc',
        labelId: 'field.accessWay',
        field: 'desc',
        initial: '',
        isUndefined: (value) => _isEmpty(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.string,
        filter: {
          field: 'desc',
        },
      },
      {
        key: 'installationCustomer',
        permissions: {
          needed: permissions.pInstallation.customerRead,
          permissionsOrContext: 'installationPermissions',
        },
        labelId: 'field.customer',
        field: 'installationCustomer',
        initial: null,
        isUndefined: (value) => _isNil(value),
        needGetOnInit: true,
        type: SEARCHFIELD_TYPES.resource,
        filter: {
          field: 'customer_id',
          key: 'id',
        },
      },
      {
        key: 'entityId',
        labelId: 'field.entityOfCustomer',
        field: 'entityId',
        initial: null,
        isUndefined: (value) => _isNil(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.resource,
        filter: {
          field: 'entity_id',
        },
      },
      {
        key: 'scenarioId',
        labelId: 'field.scenario',
        field: 'scenarioId',
        initial: null,
        isUndefined: (value) => _isNil(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.resource,
        filter: {
          field: 'scenario_id',
        },
      },
      {
        key: 'scenarioStatus',
        labelId: 'field.execScenario',
        field: 'scenarioStatus',
        alias: 'scenario_exec',
        initial: null,
        isUndefined: (value) => _isNil(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.enum,
        filter: {
          field: 'scenario_log.status',
        },
      },
      {
        key: 'triggerId',
        labelId: 'field.trigger',
        field: 'triggerId',
        initial: null,
        isUndefined: (value) => _isNil(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.resource,
        filter: {
          field: 'trigger_id',
        },
      },
      {
        key: 'scenarioTriggerType',
        labelId: 'field.accessType',
        field: 'scenarioTriggerType',
        initial: null,
        isUndefined: (value) => _isNil(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.enum,
        filter: {
          field: 'scenario_trigger_type',
        },
      },
    ],
  },
};

module.exports = installationLog;



// WEBPACK FOOTER //
// ./models/installationLog.js